// extracted by mini-css-extract-plugin
export var banner = "index-module--banner--iv5Kr";
export var container = "index-module--container--xkY+A";
export var content = "index-module--content--4j7Rw";